const ALGORITHM = 'AES-GCM';
const KEY_BITS = 256;
const IV_BYTES = 12;
export function toBase64(bytes) {
    let binary = '';
    for (const b of bytes)
        binary += String.fromCharCode(b);
    return btoa(binary);
}
// Returns Uint8Array<ArrayBuffer> rather than Uint8Array<ArrayBufferLike> so it
// satisfies BufferSource: Web Crypto will not accept a possibly-shared buffer.
export function fromBase64(b64) {
    const binary = atob(b64);
    const out = new Uint8Array(new ArrayBuffer(binary.length));
    for (let i = 0; i < binary.length; i++)
        out[i] = binary.charCodeAt(i);
    return out;
}
export async function generateQuestionKey() {
    const key = await crypto.subtle.generateKey({ name: ALGORITHM, length: KEY_BITS }, true, [
        'encrypt',
        'decrypt',
    ]);
    const raw = await crypto.subtle.exportKey('raw', key);
    return toBase64(new Uint8Array(raw));
}
async function importKey(base64Key, usage) {
    return crypto.subtle.importKey('raw', fromBase64(base64Key), { name: ALGORITHM }, false, [usage]);
}
/**
 * Server side. The body deliberately has no correctAnswer field -- the answer is
 * never in the ciphertext, encrypted or otherwise. It arrives only in the reveal
 * payload, after the host closes the question.
 */
export async function encryptQuestionBody(base64Key, body) {
    const key = await importKey(base64Key, 'encrypt');
    const iv = crypto.getRandomValues(new Uint8Array(IV_BYTES));
    const plaintext = new TextEncoder().encode(JSON.stringify(body));
    const buf = await crypto.subtle.encrypt({ name: ALGORITHM, iv }, key, plaintext);
    return { iv: toBase64(iv), ciphertext: toBase64(new Uint8Array(buf)) };
}
/** Client side, once the key arrives in a state poll. */
export async function decryptQuestionBody(base64Key, question) {
    const key = await importKey(base64Key, 'decrypt');
    const buf = await crypto.subtle.decrypt({ name: ALGORITHM, iv: fromBase64(question.iv) }, key, fromBase64(question.ciphertext));
    return JSON.parse(new TextDecoder().decode(buf));
}
//# sourceMappingURL=quizCrypto.js.map